module.exports = __webpack_public_path__ + "assets/icon-lock-light-gray.f0aa86a4.svg";